import axios from 'axios';
import { authHeader } from './authservice/auth-header';

const BASE_API = process.env.VUE_APP_BASE_API_URL;

class NewscategoryService {
    list() {
        return axios.get(BASE_API + 'news-category', { headers: authHeader() });
    }

    create(data) {
        return axios.post(BASE_API + 'news-category', data, { headers: authHeader() });
    }

    update(id, data) {
        return axios.patch(BASE_API + 'news-category/'+id, data, { headers: authHeader() });
    }

    delete(id) {
        return axios.delete(BASE_API + 'news-category/'+id, { headers: authHeader() });
    }

    deleteBulk(data) {
        return axios.post(BASE_API+'news-category/bulk-delete', data, { headers: authHeader() });
    }

    format() {
        return axios.get(BASE_API + 'news-category/download-format', { responseType: 'blob', headers: authHeader() });
    } 

    newsExport() {
        return axios.get(BASE_API+'news-category/export-news', {responseType: 'blob', headers: authHeader() });
    }

    newsImport(data) {
        return axios.post(BASE_API + 'news-category/import-news', data, { headers: authHeader(true) });
    }
}

export default new NewscategoryService();
